// Path: ./src/app/components/Pagination/index.tsx
import { Pagination, Stack } from "@mui/material";
import SelectComponent from "../SelectMui";
import { useTranslation } from "react-i18next";
import { messages } from "../../../locales/messages";
import { ChangeEvent } from "react";

interface Props {
  perPage: number;
  total: number;
  page: number;
  handlePageChange: // eslint-disable-next-line
  ((event: ChangeEvent<unknown>, page: number) => void) | undefined;
  // eslint-disable-next-line
  setPerPage: ((value: number) => void) | undefined;
}
export const CustomPagination = ({
  handlePageChange,
  page,
  perPage,
  total,
  setPerPage,
}: Props) => {
  const { t } = useTranslation();
  const RowPerPage = Array.from(Array(11).keys())
    ?.map((value) => {
      const countValue = value * 10;
      return {
        label: `${countValue}`,
        value: countValue,
      };
    })
    .filter((val) => val.value != 0);
  return (
    <Stack
      direction="row"
      spacing={2}
      rowGap={2}
      flexWrap="wrap"
      alignItems={"center"}
      justifyContent={"center"}
      data-testid="custompagination-test-id"
    >
      <SelectComponent
        title={`${t(messages.Rows_PerPage())} : `}
        selectedValue={perPage}
        selectOptions={RowPerPage}
        onSelect={(value) => {
          setPerPage && setPerPage(value);
        }}
        wrapperStyle={`
          flex-direction: row;
          align-items: center;
          justify-content: start;
          `}
        borderColor={{
          normal: "#dedede",
        }}
      ></SelectComponent>
      <Pagination
        count={Math.ceil(total / perPage)}
        page={page}
        onChange={handlePageChange}
      />
    </Stack>
  );
};
